<template>
  <div class="sticky-table-header">
    <div
      class="sticky-table"
      :class="{ 'disable-share': disableShare }"
    >
      <div class="sticky-table-row sticky-thead">
        <div
          v-if="!disableShare"
          class="sticky-table-cell sticky-checkbox"
        >
          <DpplSimpleCheckbox
            :model-value="allSelected"
            hide-label
            size="md"
            border-radius="6px"
            @click.stop
            @update:model-value="$emit('selectAll')"
          />
        </div>
        <div
          v-for="header in headers"
          :key="header.text"
          class="sticky-table-cell"
          :class="{ title: header.text === 'Job Title' }"
          :style="{
            width: header.width || 'auto',
            minWidth: header.width || 'auto',
            textAlign: header.align === 'center' ? 'center' : 'start',
          }"
        >
          <span :class="header.class || ''">
            {{ header.text }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DpplSimpleCheckbox from '@/components/datapeople/DpplSimpleCheckbox.vue';

export default {
  name: 'StickyTable',
  components: {
    DpplSimpleCheckbox,
  },
  props: {
    allSelected: {
      type: Boolean,
      default: false,
    },
    headers: {
      type: Array,
      default: () => [],
    },
    disableShare: {
      type: Boolean,
      default: false,
    },
    otherNumberOfColumns: {
      type: Number,
      default: 0,
    },
  },
  emits: ['selectAll'],
};
</script>

<style lang="less" scoped>
.sticky-table-header {
  position: sticky;
  background: @white;
  top: 208px;
  z-index: 2;
  font-size: 12px;
  line-height: 18px;
  font-weight: 700;
  color: fade(@grey-900, 70%);
  height: 100%;
  width: 100%;
}

.sticky-table {
  display: grid;
  background: @bg-input;
  border-bottom: 1px solid @stroke-default;
  width: 100%;
  overflow: hidden;
  grid-template-columns: 42px minmax(180px, 715px) 116px repeat(v-bind(otherNumberOfColumns), minmax(90px, 95px)) minmax(85px, 266px);

  &.disable-share {
    grid-template-columns: minmax(180px, 715px) 116px repeat(v-bind(otherNumberOfColumns), minmax(90px, 95px)) minmax(85px, 266px);

    .sticky-table-cell:first-child{
      border-right: none !important;
    }
  }
}

.sticky-table-row {
  display: contents;
}

.sticky-table-cell {
  display: flex;
  align-items: center;
  padding: 0 16px;
  height: 42px;

  &:not(:last-child):not(.title) {
    border-right: 1px solid @stroke-default;
  }
}

.sticky-checkbox {
  padding: 0 !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.first-cell {
  width: 32px;
}

.last-cell {
  width: 85px;
}

.missing-statement {
  width: 12px;
}
</style>
